<!-- Buy.vue -->
<template>
	<div class="ui-buy-wrapper ui-detail-common" v-if="detailInfo">
		<div class="buy-wrapper header" @click="changeCartState()" v-if="this.activeBuy()">
			<p v-if='number <= 0 && chooseinfo.ids.length <= 0 && vcPeriod == ""'>请选择购买{{chooseinfo.specification.join(',')}}数量分类 {{this.showSelectedPeriod()}}</p>
			<p v-if='number <= 0 && chooseinfo.ids.length > 0 '>已选{{chooseinfo.specification.join(',') }},数量{{number+1}}</p>
			<p v-if='number <= 0 && vcPeriod!=""'>已选{{this.showSelectedPeriod()}},数量{{number+1}}</p>
			<p v-if='number > 0 && chooseinfo.ids.length <= 0'>已选数量{{number}} {{this.showSelectedPeriod()}}</p>
			<p v-if='number > 0 && chooseinfo.ids.length > 0 '>已选{{chooseinfo.specification.join(',') }},数量{{number}}</p>
			<img src="../../../assets/image/change-icon/enter@2x.png">
		</div>
		<div class="buy-wrapper header isopacity" v-if="!this.activeBuy()">
			<p v-if='number <= 0 && chooseinfo.ids.length <= 0 && vcPeriod == ""'>请选择购买{{chooseinfo.specification.join(',')}}数量分类</p>
			<p v-if='number <= 0 && chooseinfo.ids.length > 0 '>已选{{chooseinfo.specification.join(',') }},数量{{number+1}}</p>
			<p v-if='number <= 0 && vcPeriod!=""'>已选{{this.showSelectedPeriod()}},数量{{number+1}}</p>
			<p v-if='number > 0 && chooseinfo.ids.length <= 0'>已选数量{{number}} {{this.showSelectedPeriod()}}</p>
			<p v-if='number > 0 && chooseinfo.ids.length > 0 '>已选{{chooseinfo.specification.join(',') }},数量{{number}}</p>
			<img src="../../../assets/image/change-icon/enter@2x.png">
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations } from 'vuex';
	export default {
		data(){
			return{}
		},

		computed: {
			...mapState({
		      	number: state => state.detail.number,
		      	detailInfo: state => state.detail.detailInfo,
		      	chooseinfo: state => state.detail.chooseinfo,
						vcPeriod: state => state.detail.vcPeriod,
	      	    isExchange: state => state.score.isExchange,
	      	    exchangeScore: state => state.score.exchangeScore,
	      	    currentScore: state => state.score.currentScore,
		    }),
		},

		created() {
			this.saveNumber(0);
		},

		watch: {
			detailInfo: function(value) {
				this.setSpecification();
			}
		},

		methods: {
			...mapMutations({
				saveCartState: 'saveCartState',
				saveChooseInfo: 'saveChooseInfo',
				saveVcperiod: 'saveVcperiod',
				saveNumber: 'saveNumber',
				changeType: 'changeType'
			}),

			showSelectedPeriod: function() {
				if (this.detailInfo.extension_code == 'virtual_card' && this.detailInfo.vcard && this.detailInfo.vcard.type>0 && this.detailInfo.vcard.periods.length>0 && this.vcPeriod!='') {
					for (let i = 0; i <= this.detailInfo.vcard.periods.length - 1; i++) {
						if (this.vcPeriod == this.detailInfo.vcard.periods[i]['value']) {
							return this.detailInfo.vcard.periods[i]['display'];
						}
					}
				}
				return '';
			},

		    activeBuy: function() {
					// 周期性虚拟卡
					/*if (this.detailInfo.extension_code == 'virtual_card' && (this.detailInfo.vcard && this.detailInfo.vcard.type>0)) {
						if (this.detailInfo.vcard.periods.length == 1) {
							return true;
						} else {
							
						}
						return false;
					}*/

					// 普通商品和非周期性虚拟卡
		    	if ((this.detailInfo.good_stock > 0 && (this.detailInfo.extension_code != 'virtual_card' || (this.detailInfo.vcard && this.detailInfo.vcard.type<=0)))
						|| (this.detailInfo.extension_code == 'virtual_card' 
						&& (this.detailInfo.vcard && this.detailInfo.vcard.type>0 && this.detailInfo.vcard.periods.length > 0))) {
		    		if (this.isExchange) {
		    			if (this.currentScore >= this.exchangeScore) {
		    				return true;
		    			} else {
		    				return false;
		    			}
		    		} else {
		    			return true;
		    		}
		    	} else {
		    		return false;
		    	}
		    },

			changeCartState() {
				this.saveCartState(true);
				this.changeType('加入购物车');
			},

			setSpecification() {
				if (this.detailInfo && this.detailInfo.properties) {
					let data = this.detailInfo.properties;
					let arrays = [];
					for (let i = 0; i <= data.length -1; i++) {
						arrays.push(data[i].name);
					}
					this.saveChooseInfo({'specification': arrays, 'ids': []});
				}
				// initialize virtual card
				if (this.detailInfo && this.detailInfo.extension_code == 'virtual_card') {
					this.saveVcperiod('');
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.ui-buy-wrapper {
		.buy-wrapper {
			&.header {
				padding: 0px;
				height: 50px;
			}
			&.isopacity {
				opacity: 0.5;
			}
			p {
				font-size:16px;
				color:rgba(78,84,93,1);
				line-height:20px;
				padding: 0px;
				margin: 0px;
				i {
					font-weight: normal;
					font-style: normal;
				}
			}
			img {
				width:5px;
				height:10px;
				cursor: pointer;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/product-detail/child/InfoBuy.vue